'use client';
import { Accordion, AccordionItem } from '@nextui-org/react';
import { NextUIProvider } from '@nextui-org/system';
import Image from 'next/image';
import { useState } from 'react';
import add from '../../../public/svg/add.svg';
import addlight from '../../../public/svg/addlight.svg';
import minus from '../../../public/svg/minus.svg';
import minuslight from '../../../public/svg/minuslight.svg';
import { IFaqsData } from '../type/type';

interface IAccordionProps {
  data: IFaqsData[];
  isDarkbg?: boolean;
}

const FaqsAccordion = ({ data, isDarkbg }: IAccordionProps) => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <NextUIProvider>
      <Accordion variant="splitted" className="!px-0">
        {data &&
          data.map((item, index) => {
            const isExpanded = expandedIndex === index;

            return (
              <AccordionItem
                key={index}
                aria-label={`Accordion ${index + 1}`}
                title={
                  <div
                    className={`flex flex-col gap-3 md:flex-row md:items-center md:gap-6 ${isExpanded ? 'py-0' : 'py-0'}`}
                  >
                    <span
                      className={`font-dmSans text-lg font-semibold leading-[22px] ${isDarkbg ? 'text-white' : 'text-primary'}`}
                    >
                      {index + 1 < 10 ? `0${index + 1}` : index + 1}
                    </span>
                    <span
                      className={`font-dmSans text-lg font-normal leading-[22px] ${isDarkbg ? 'text-white' : 'text-primary'}`}
                    >
                      {item?.question}
                    </span>
                  </div>
                }
                indicator={
                  <Image
                    src={
                      isExpanded
                        ? isDarkbg
                          ? minuslight
                          : minus
                        : isDarkbg
                          ? addlight
                          : add
                    }
                    alt={isExpanded ? 'Collapse' : 'Expand'}
                    width={24}
                    height={24}
                    className={`${isExpanded && 'rotate-90'}`}
                  />
                }
                className={`wer !rounded-none border-b !bg-transparent !px-0 !py-0 !shadow-none ${isDarkbg ? 'border-b-white/30' : 'border-b-bluishGray'}`}
                onPress={() => handleToggle(index)}
              >
                <p
                  className={`w-full max-w-[619px] pb-3 font-dmSans text-base font-normal leading-5 lg:ml-[52px] ${isDarkbg ? 'text-white' : 'text-optDesc'}`}
                >
                  {item?.answer}
                </p>
              </AccordionItem>
            );
          })}
      </Accordion>
    </NextUIProvider>
  );
};

export default FaqsAccordion;
